import Loadable from 'react-loadable';

import { LoadingPageLoadable } from 'modules/main/pages/Loading';

export const CompensationSurveyLoadable = Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "CompensationSurvey" */
      './CompensationSurvey.dynamic'
    ),
  loading: LoadingPageLoadable,
});
